import * as actions from "./actions"
import reducer from "./reducer"
import * as selectors from "./selectors"

const name = `ui`

export { name, actions, reducer, selectors }

export const SIDEBAR_WIDTH = 259
export const SIDEBAR_COMPACT_WIDTH = 56
